import { api } from './api';

export const gradeApi = api.injectEndpoints({
  endpoints: builder => ({
    generateGrades: builder.mutation({
      query: ({ campId }) => ({
        url: '/grade/generate_grades_and_rubricgrades',
        method: 'POST',
        body: { campId },
      }),
    }),
    getGenerateGradesStatus: builder.query({
      query: ({ campId }) => `/grade/generate-grades-status?campId=${campId}`,
    }),
  }),
  overrideExisting: false,
})

export const {
  useGenerateGradesMutation,
  useGetGenerateGradesStatusQuery,
} = gradeApi
